
export const selectChargesColumn = [
  { label: "Item Type", hoverDescription: "Item Type" },
  { label: "Due Date", hoverDescription: "Due Date" },
  { label: "Term", hoverDescription: "Term" },
  { label: "Course ID", hoverDescription: "Course ID" },
  { label: "Description", hoverDescription: "Description" },
  { label: "Item Amount", hoverDescription: "Base Fees without Tax" },
  { label: "Net Payable ", hoverDescription: "Taxable Amount after applying concession" },

  { label: "Total Fee Paid", hoverDescription: "Fees already PAID by the student" },
  { label: "Balance", hoverDescription: "Net Outstanding (Total Amount-Total Fees Paid)" },
  { label: "Status", hoverDescription: "Status" },
  
];

